module.exports = __webpack_public_path__ + "img/android.dad80438.png";